import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import { useSelector } from "react-redux";
import home from "../assets/home-2.svg"
import bank from "../assets/bank.svg"
import profile from "../assets/profile-add.svg"


function Layout() {

  const { currentLocal } = useSelector((state) => state.currentLocal);
  const sidebarItems = localStorage.getItem("type") == "admin" ?

    [
      { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
            {
        name: currentLocal.home.SchoolStracture, icon: profile, path: "school-structure", subTabs: [
          { name: currentLocal.home.stages, icon: profile, path: "structure/stages" },
          { name: currentLocal.home.grades, icon: profile, path: "structure/grades" },
        ]
      },
          { name:currentLocal.home.classes, icon: profile, path: "classes" },
          { name:currentLocal.home.attendanceHistory, icon: profile, path: "attendance-history" },

      {
        name: currentLocal.home.Finance, icon: profile, path: "code", subTabs: [
          // { name: currentLocal.home.all, icon: profile, path: "finance/all" },
          { name: currentLocal.home.Sales, icon: profile, path: "finance" },
          { name: currentLocal.home.Purchases, icon: profile, path: "Purchases" },
          { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },
          { name: currentLocal.home.Maintenance, icon: profile, path: "maintenance" },
        ]
      },
      {
        name: currentLocal.home.Studyexpenses, icon: profile, path: "expenses/all",

      },
      // { name: currentLocal.home.Presenceandabsence, icon: bank, path: "tarteeb" },
      // { name: currentLocal.home.Teacherreserve, icon: '', path: "teacherreserve" },
      // { name: currentLocal.home.students, icon: bank,path:"students" },

      {
        name: currentLocal.home.students, icon: profile, path: "students", subTabs: [
          // { name: currentLocal.home.all, icon: profile, path: "finance/all" },
          { name: currentLocal.home.studentDataTitle, icon: profile, path: "students/info" },
          // { name: currentLocal.home.mainexpenses, icon: profile, path: "students/expenses" },
          { name: currentLocal.home.mainexpenses, icon: profile, path: "students/expenses" },
          { name: currentLocal.home.Transporttype, icon: profile, path: "students/transport" },
          { name: currentLocal.home.Doeshesufferfromanyillnesses, icon: profile, path: "students/illnesses" },
        ]
      },
      { name: currentLocal.home.permissions, icon: bank, path: "permissions" },
    // { name: currentLocal.home.settings, icon: bank,path:"school-settings" },


    ] : localStorage.getItem("type") == "maintenance" ?



      [
        { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
        { name: currentLocal.home.Maintenance, icon: profile, path: "maintenance" },


      ] : localStorage.getItem("type") == "salaries" ?



        [
          { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
          { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },


        ]
        : localStorage.getItem("type") == "sales" ?



          [
            { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
            // { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },
            { name: currentLocal.home.students, icon: profile, path: "finance" },


            //         { name:currentLocal.home.Studyexpenses , icon: profile, path: "code1", subTabs: [
            //     { name: currentLocal.home.all, icon: profile, path: "expenses/all" },
            //     { name: currentLocal.home.Exceptions, icon: profile, path: "expenses/exceptions" },
            //   ]
            // },


          ]
          : localStorage.getItem("type") == "purchases" ?



            [
              { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
              { name: currentLocal.home.Purchases, icon: profile, path: "Purchases" },


            ]
            : localStorage.getItem("type") == "financial" ?

              [
                { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
                // { name: currentLocal.home.Generaldata, icon: bank, path: "products" },
                // { name: currentLocal.home.Finance, icon: bank,path:"codes" },
                {
                  name: currentLocal.home.Finance, icon: profile, path: "code", subTabs: [
                    // { name: currentLocal.home.all, icon: profile, path: "finance/all" },
                    { name: currentLocal.home.Sales, icon: profile, path: "finance" },
                    { name: currentLocal.home.Purchases, icon: profile, path: "Purchases" },
                    { name: currentLocal.home.Salaries, icon: profile, path: "salaries" },
                    { name: currentLocal.home.Maintenance, icon: profile, path: "maintenance" },
                  ]
                },
                {
                  name: currentLocal.home.Studyexpenses, icon: profile, path: "expenses/all",

                },
                // { name: currentLocal.home.Presenceandabsence, icon: bank,path:"tarteeb" },
                // { name: currentLocal.home.Teacherreserve, icon: bank,path:"teacherreserve" },
                // { name: currentLocal.home.settings, icon: bank,path:"settings" },


              ]
              :localStorage.getItem("type") == "teacher"?[
    { name: currentLocal.home.dashboard, icon: home, path: "Dashboard" },
    { name:currentLocal.home.markAttendance, icon: profile, path: "mark-attendance" },
    { name:currentLocal.home.Lateattendance, icon: profile, path: "lateattendance" },

              ]:localStorage.getItem("type") == "DataEntry" ?[
                      { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
          { name:currentLocal.home.attendanceHistory, icon: profile, path: "attendance-history" },
      {
        name: currentLocal.home.students, icon: profile, path: "students", subTabs: [
          // { name: currentLocal.home.all, icon: profile, path: "finance/all" },
          { name: currentLocal.home.studentDataTitle, icon: profile, path: "students/info" },
          // { name: currentLocal.home.mainexpenses, icon: profile, path: "students/expenses" },
          // { name: currentLocal.home.mainexpenses, icon: profile, path: "students/expenses" },
          { name: currentLocal.home.Transporttype, icon: profile, path: "students/transport" },
          { name: currentLocal.home.Doeshesufferfromanyillnesses, icon: profile, path: "students/illnesses" },
        ]
      },

              ] :[

                { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
                { name: currentLocal.home.Finance, icon: bank, path: "student/Finance" },
                // { name: currentLocal.home.timeTable, icon: bank,path:"TimeTable" },
                // { name: currentLocal.home.forms, icon: bank,path:"forms" },

                // { name: currentLocal.home.tests, icon: bank,path:"tests" },
                // { name: currentLocal.home.attendanceHistory, icon: bank,path:"AttendanceHistory" },




              ]




  //   ] : userinfo && userinfo.role === "School Manager" ? [

  //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
  //     {
  // name:currentLocal.home.SchoolStracture , icon: profile, path: "school-structure", subTabs: [
  //   { name: currentLocal.home.stages, icon: profile, path: "structure/stages" },
  //   { name: currentLocal.home.grades, icon: profile, path: "structure/grades" }
  // ]
  //     },
  //     { name:currentLocal.home.subjects, icon: profile, path: "Subjects" },
  //     { name:currentLocal.home.teachers , icon: profile, path: "Teachers" },

  //     { name: currentLocal.home.classes, icon: profile, path: "Classes" },
  //     { name:currentLocal.home.students , icon: profile, path: "Students" },
  //     { name:currentLocal.home.attendanceHistory, icon: profile, path: "attendance-history" },
  //     { name: currentLocal.home.settings, icon: bank,path:"school-settings" },






  //   ] : [
  //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
  //     { name:currentLocal.home.markAttendance, icon: profile, path: "mark-attendance" },
  //   ]
  return (

    <div style={{ display: "flex", height: "100vh" }}>
      <div className="mdQuery">
        <Sidebar
          sidebarItems={sidebarItems}

        />
      </div>
      <div className="normalQuery">
        <Sidebar
          sidebarItems={sidebarItems}

        />
      </div>
      <div style={{ flex: 1, height: "100vh", overflowY: "scroll" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
